// extracted by mini-css-extract-plugin
module.exports =  {"insightSummaryRoot":"InsightSummary-module__insightSummaryRoot--l2HCK","insightCardWrapper":"InsightSummary-module__insightCardWrapper--jbA13"};